import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Profile } from 'src/app/assabil-kernel/models/entities/master-data/profile-entity';
import { ProfileRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/profile-request';
import { ProfileAssabilMenu } from 'src/app/assabil-kernel/models/entities/master-data/profile-assabil-menuentity';


@Component({
    selector: 'profile-widget',
    templateUrl: './profile-widget.component.html',
    styleUrls: ['./profile-widget.component.scss']
})

export class ProfileWidgetComponent extends BaseWidget {
  
  profile            : Profile = new Profile();

 //---------------------------------------------------------------------------------------
  constructor(
      protected promoService         : PromoService,
      protected toastr               : ToastrService,
      protected leanUtilsService     : LeanUtilsService,
      protected controlTablesService : ControlTablesService) {
      super(toastr, leanUtilsService);

      this.entityName = "profile";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(profile: Profile) {
      this.profile  = { ...profile };
      this.profile.profileAssabilMenus = [];
      if (profile.profileAssabilMenus) {
        for (let profileAssabilMenu of profile.profileAssabilMenus) {
          this.profile.profileAssabilMenus.push({ ...profileAssabilMenu });
        }
      }
    }
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.profile;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<Profile> {
  let request: ProfileRequest = new ProfileRequest(this.controlTablesService.getUserInfo());
  request.profile = this.profile;
  return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let profileAssabilMenu : ProfileAssabilMenu = new ProfileAssabilMenu();

  profileAssabilMenu.inserted = true;
  this.profile.profileAssabilMenus.push(profileAssabilMenu);
  this.profile.profileAssabilMenus = [...this.profile.profileAssabilMenus];
}
//----------------------------------------------------------------------


}
